// extracted by mini-css-extract-plugin
module.exports = {"Status":"src-components-Main-Status-Status--1RaUT","rowOne":"src-components-Main-Status-Status--8XVD2","rowTwo":"src-components-Main-Status-Status--m92WQ"};